import {Checkbox} from 'antd';
import cn from 'classnames';
import PropTypes from 'prop-types';
import React, {memo} from 'react';
import {useTranslation} from 'react-i18next';

const CheckInput = ({title, translate, className, ...props}) => {
  const {t} = useTranslation(translate || 'common');

  return (
    <Checkbox className={cn('mx-0 my-px', className)} size={'large'} {...props}>
      {t(title)}
    </Checkbox>
  );
};

CheckInput.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  translate: PropTypes.string,
};

export default memo(CheckInput);
